import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Trans } from 'gatsby-plugin-react-i18next'

import { Section, Container, Text, Card, MoneyBackContainer, Box, FlexBox, Header } from './styles'
import { GUARANTEE_CONSTANTS } from './constants'
import { IS_FOREIGN_COUNTRY } from '../../utils/constants'

const Guarantee = () => {
  const { guaranteeLogo, internationalGuaranteeLogo, moneybackLogo } = useStaticQuery(graphql`
    query GuaranteeQuery {
      guaranteeLogo: file(relativePath: { eq: "dog-gold-frame.webp" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      internationalGuaranteeLogo: file(relativePath: { eq: "daughter-ballerina.webp" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      moneybackLogo: file(relativePath: { eq: "money-back.webp" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
        }
      }
    }
  `)
  const { headline, subheadline } = GUARANTEE_CONSTANTS

  const moneyBack = moneybackLogo
  const guaranteeImage = IS_FOREIGN_COUNTRY ? internationalGuaranteeLogo : guaranteeLogo

  return (
    <>
      <Section>
        <Container flexWrap="wrap-reverse">
          <Card>
            <Box>
              <GatsbyImage
                image={guaranteeImage.childImageSharp.gatsbyImageData}
                alt={
                  IS_FOREIGN_COUNTRY
                    ? 'Father and daughter ballet picture displayed on a Skylight Black Frame'
                    : 'Beautiful Dog picture displayed on a Skylight Gold Frame'
                }
              />
              <FlexBox>
                <MoneyBackContainer>
                  <GatsbyImage
                    image={moneyBack.childImageSharp.gatsbyImageData}
                    alt="Money Back Guarantee"
                  />
                </MoneyBackContainer>
              </FlexBox>
            </Box>
          </Card>
          <Card>
            <div>
              {!IS_FOREIGN_COUNTRY && <Header>{headline}</Header>}
              <Text>
                <Trans>
                  {IS_FOREIGN_COUNTRY
                    ? `With hundreds of thousands of happy customers, we're confident that you'll love Skylight. That's why we offer a 100% satisfaction guarantee, or your money back.`
                    : { subheadline }}
                </Trans>
              </Text>
            </div>
          </Card>
        </Container>
      </Section>
    </>
  )
}

export default Guarantee
